import React, { useEffect, useState } from "react"
import { LOGIN, STUDENT } from "../../utils";
import BaseService from "../../store/services/base.service";
import { setKneuraId, setUserId, setInstituteId, setToken, setusername, setNotificationToken, setInstituteKneuraId } from "../../utils/authentication-access";
import { setTokenOnLogin } from "../../utils/api-authentication";
import assessmentService from "../../store/services/assessment.service";
import { useLocation, useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setIsWebView, setIsKtvAssessment } from "../../store/actions/assessment.action";
import { AssessmentNotAvailable } from "./assessmentNotAvailable"

const componentPath = "/start-test?assessmentId=";
const routePath = "/webview/assessment/attempt/"

const loginViaUserToken = async (userToken) => {
    const url = LOGIN.loginViaToken(userToken);
    const { data } = await new BaseService().makePostRequestGeneric(url);

    sessionStorage.clear();

    setKneuraId(data.kneura_id);
    setUserId(data.userId);
    setInstituteKneuraId(data.instituteKneuraId);
    setInstituteId(data.instituteId);
    setToken(data.access_token);
    setTokenOnLogin(data.access_token);
    setusername(data.first_name);
    setNotificationToken(data.notificationToken);

    return data;
}

export const AssessmentAttempt = () => {
    const [errorText, setErrorText] = useState("")
    const [loadingText, setLoadingText] = useState("Loading ...")
    const [showAssessmentNotAvailable, setShowAssessmentNotAvailable] = useState(false)
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        const { pathname, search } = location;
        const token = new URLSearchParams(search).get("token");
        if (!token) {
            setErrorText("Invalid credentials")
            setLoadingText("")
            return () => { };
        }
        const pathKeys = pathname.split(routePath);
        if (pathKeys.length !== 2) {
            setErrorText("Invalid Path")
            setLoadingText("")
            return () => { }
        }
        const assessmentId = pathKeys[1];




        async function login() {
            const userData = await loginViaUserToken(token);
            const { isAssessmentPublished } = await assessmentService.isPublished(assessmentId)
            if (!isAssessmentPublished) {
                setErrorText("")
                setLoadingText("")
                setShowAssessmentNotAvailable(true)
                return
            }
            const assessmentData = await assessmentService.read(assessmentId);
            const { classId } = assessmentData;


            const classFetchURL = STUDENT.getStudentClass();
            const baseService = new BaseService();
            const res = await baseService.makeGetRequestGeneric(classFetchURL, {
                role: "learner",
                institute_kneura_id: userData.instituteKneuraId,
                user_kneura_id: userData.kneura_id,
                access_token: token,
            });

            const classInfo = res.data.find((item) => item.kneuraId === classId);

            const isKtvAssessment = new URLSearchParams(search).get("isKTV");
            dispatch(setIsWebView(true));
            dispatch(setIsKtvAssessment(isKtvAssessment == "true"))

            // console.log({ assessmentData })



            sessionStorage.setItem(
                "classinfo",
                JSON.stringify({
                    ...classInfo,
                }),
            );


            sessionStorage.setItem("assessmentinfo",
                JSON.stringify({
                    id: assessmentData.id,
                    showClose: false,
                    // not extra keys to customize ui can come here
                })
            )
            localStorage.setItem("_assessmentId", assessmentId)
            const updatedComponentPath = `${componentPath}${assessmentId}`


            history.push(updatedComponentPath);
        }

        login();

    }, [location])



    return (
        <>
            <h1 style={{ display: loadingText.length === 0 ? "none" : "block" }}>{loadingText}</h1>
            <h2 style={{ color: "red", display: errorText.length === 0 ? "none" : "block" }}>{errorText}</h2>
            <AssessmentNotAvailable
                showAssessmentNotAvailable={showAssessmentNotAvailable} />
        </>
    )



}